import { render, staticRenderFns } from "./RegistrationAddressComponent.vue?vue&type=template&id=4309d8ae&lang=pug&"
import script from "./RegistrationAddressComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistrationAddressComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports